import React, { PureComponent } from "react";
import { connect } from "react-redux";

import {
  initBalanceSheet,
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle,
  setBalanceSheetOrganization,
  initAnnexeList
} from "Actions";
import BalanceSheet from "./BalanceSheet";
import { fetchBalanceSheet, fetchBalanceSheetAttachments } from "Thunks";
import { HORIZONTAL, VERTICAL } from "Config";
import HeaderFicheClient from "../FicheClient/HeaderFicheClient";

class BalanceSheetPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen, year } = this.props.match.params;
    this.state = { organizationUen: uen, dashboardId: 4, year: year };
  }

  componentDidMount() {
    const {
      dispatch,
      subMenuDirection,
      organization,
      currentOrganization
    } = this.props;
    const { organizationUen } = this.state;

    dispatch(setCurrentNavPage("BALANCE_SHEET_PAGE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(false));
    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });

    dispatch(initAnnexeList());
    if (!organization) {
      if (!organizationUen) {
        return false;
      }

      dispatch(fetchBalanceSheet(organizationUen, null));
      dispatch(fetchBalanceSheetAttachments(organizationUen));
    } else {
      if (organizationUen === currentOrganization.uen) {
        dispatch(setBalanceSheetOrganization(currentOrganization));
      }

      dispatch(initBalanceSheet());
      dispatch(fetchBalanceSheet(organizationUen, null));
      dispatch(fetchBalanceSheetAttachments(organizationUen));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(setSubMenuDirectionToggle(true));
  }

  render() {
    const { organization } = this.props;
    return (
      <div
        className={`page-content`}
        style={{
          backgroundColor: `#FAFBFB`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain"
        }}
      >
        <HeaderFicheClient
          currentPage="BALANCE_SHEET"
          organization={organization}
          selectedYear={this.state.year}
        />
        <BalanceSheet uen={this.state.organizationUen} />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.balanceSheet.fetching,
  fetched: state.balanceSheet.fetched,
  balanceSheet: state.balanceSheet,
  organization: state.balanceSheet.organization,
  subMenuDirection: state.params.subMenuDirection,
  currentOrganization: state.auth.currentOrganization,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro
});

export default connect(mapStateToProps)(BalanceSheetPage);



// WEBPACK FOOTER //
// ./src/components/BalanceSheet/BalanceSheetPage.js